// extracted by mini-css-extract-plugin
module.exports = {"flashContainer":"FlashMessage_flashContainer__0ugAi"};